import { makeStyles, shorthands } from "@fluentui/react-components";
import * as React from "react";
import type { App } from "./AppNavItem.web.data";

const useStyles = makeStyles({
  img: {
    width: "80px",
    height: "80px",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,.14)",
    ...shorthands.borderRadius("8px"),
  },
});

type Props = {
  app: App;
  expanded: boolean;
};

export const AppNavItem: React.FC<Props> = ({ app, expanded }) => {
  const styles = useStyles();
  const [tabIndex, setTabIndex] = React.useState(0);
  React.useEffect(() => {
    const setTabIndexFunction = () => {
      const parentElement = document.querySelector("ul#app-nav-list");
      const element = parentElement?.querySelector(`a[title="${app.text}"]`);
      if (parentElement && element) {
        const parentRect = parentElement.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        if (
          elementRect.left < parentRect.left ||
          elementRect.right > parentRect.right ||
          elementRect.top < parentRect.top ||
          elementRect.bottom > parentRect.bottom
        ) {
          setTabIndex(-1);
        } else {
          setTabIndex(0);
        }
      }
    };
    // Add event listener
    window.addEventListener("resize", setTabIndexFunction);

    // Call handler right away so state gets updated with initial window size
    setTabIndexFunction();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", setTabIndexFunction);
  }, [app.text, expanded]);
  return (
    <li>
      <a
        title={app.text}
        href={app.link}
        aria-label={app.text}
        target="_blank"
        rel="noreferrer"
        tabIndex={tabIndex}
        data-telemetry-urls="true"
      >
        <img
          src={app.imgSrc}
          loading="lazy"
          alt={app.imgAlt}
          aria-hidden="true"
          className={styles.img}
        />
      </a>
    </li>
  );
};
